import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchInvoice } from '#/modules/orgDashboard/api/invoice/orgDashboardApiClientFetchInvoice';
import { orgDashboardViewInvoiceRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardInvoiceViewPageContainerLoadable } from './OrgDashboardInvoiceViewPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, invoiceId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardViewInvoiceRoute>) {
  const [{ invoice }] = await Promise.all([
    orgDashboardApiIsomorphicFetchInvoice({ request, context })(
      orgId,
      invoiceId,
    ),
    OrgDashboardInvoiceViewPageContainerLoadable.load(),
  ]);

  return { invoice };
}

export default function OrgDashboardViewInvoiceHorizonRoute({
  loaderData: { invoice },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={i18n('Invoice #%(invoiceNumber)s', {
        invoiceNumber: invoice.number ?? '',
      })}
    >
      <OrgDashboardInvoiceViewPageContainerLoadable initialInvoice={invoice} />
    </RouteModule>
  );
}
